export const WHALE_PORTRAIT_URL = '/art/scenes/whale.webp';
export const WHALE_ICON_URL = '/art/account/whale.webp';

/** Keep existing catalog keys while shipping the approved whale artwork with the app. */
export function animalAssetUrl(key: string, suffix = ''): string {
  if (key === 'scenes/whale.svg') return WHALE_PORTRAIT_URL;
  return `/api/v1/assets/${key}${suffix}`;
}
